// @flow
import { Control } from "biologiatotal-ui";
import React from "react";
import InputMask from "react-input-mask";
import "./inputMask.scss";

const InputDefaultMask = React.forwardRef(
  (
    {
      name,
      placeholder,
      label,
      mask,
      danger,
      onChange,
      type,
      defaultValue,
      required,
      disabled,
      onFocus,
      onBlur,
      className,
      loading
    },
    ref
  ) => {
    let validate = danger ? "input-mask-error" : "";
    let error = danger ? "error-input" : "";
    let requiredClass = required ? "input-required" : "";

    return (
      <Control className="platforma-mask">
        {/*<span className={`platforma-mask-label ${requiredClass} ${error} ${loading}`}>{label}</span>*/}
        <InputMask
          name={name}
          mask={mask}
          maskChar=""
          disabled={disabled}
          className={`platforma-mask-input input-mask ${validate} ${className}`}
          placeholder={placeholder}
          danger={danger}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          type={type}
          defaultValue={defaultValue}
          inputRef={ref}
        />
        {danger ? <span className={`platforma-mask-error error-label`}>{danger}</span> : null}
      </Control>
    );
  }
);

export default InputDefaultMask;
